<script setup>
import { tv } from 'tailwind-variants';

/**
 * @typedef {object} EditorToolbarProps
 * @property {('default'|'dark'|'caution'|'inverse')} [variant='default'] - The visual tone of the editor toolbar.
 */

/** @type {EditorToolbarProps} */
const props = defineProps({
  variant: {
    type: String,
    default: 'default',
  },
});

const toolbarRecipe = tv({
  base: ['px-2 py-1 flex items-center'],
  variants: {
    variant: {
      default: 'bg-brand-gray-4 dark:bg-brand-gray-15 rounded-t-lg',
      dark: 'bg-brand-gray-15 dark:bg-brand-gray-15 dark:border dark:border-brand-gray-14',
      inverse:
        'bg-brand-gray-15 dark:bg-brand-gray-15 dark:border dark:border-brand-gray-14',
      caution: 'bg-brand-surface-caution-active rounded-t-lg',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});
</script>

<template>
  <div data-component="CsToolbarContainer" :class="toolbarRecipe(props)">
    <slot />
  </div>
</template>
